module.exports = __webpack_public_path__ + "img/39_61.abd144e0.png";